// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__XODJe","head":"ProcedureTableInfo_head__2h3CA"};